<template>
  <div class="invoice">
    <div class="topClass">
      <h3>{{ $t('Invoice.Settings') }}</h3>
    </div>
    <div class="main">
      <div class="main-top">
        <Button
          class="w100 mb10"
          type="primary"
          @click="showBTn"
          v-has="'WSS-50003-edit'"
          >{{ $t('Invoice.Add') }}</Button
        >
        <div class="main-total borderB">
          {{ $t('Invoice.Created') }}
          <i>{{ total }}</i>
          {{ $t('Invoice.delivery') }}
          <i>{{ number }}</i>
          个
        </div>
      </div>
      <div class="main-center">
        <div v-if="tableData.length > 0">
          <div v-for="item in tableData" :key="item.id">
            <div class="itemFlexClass borderB">
              <!--左-->
              <div class="itemLeftClass">
                <!--上-->
                <div class="itemLeftTopClass">
                  <div class="h3 pr10">{{ item.invoiceName }}</div>
                  <div v-if="item.isDefault" class="defauldAddress">
                    <span>{{ $t('Invoice.default') }}</span>
                  </div>
                </div>
                <!--下-->
                <div class="invoiceTaxId">{{ $t('Invoice.number') }}：{{ item.invoiceTaxId }}</div>
              </div>
              <!--右-->
              <div class="itemRightClass">
                <span
                  v-has="'WSS-50003-edit'"
                  class="span-btn"
                  @click="changeBtn(item)"
                  >{{ $t('Invoice.Revise') }}</span
                >
                <span
                  v-has="'WSS-5002-edit'"
                  class="span-btn"
                  @click="del(item.id)"
                  >{{ $t('Invoice.delete') }}</span
                >
              </div>
            </div>
          </div>
        </div>
        <div v-if="!tableData.length" class="table-empty">{{ $t('shopping.No') }}</div>
      </div>
      <!--      <vxe-table-->
      <!--        border-->
      <!--        align="center"-->
      <!--        :data="tableData"-->
      <!--        show-overflow-->
      <!--        ref="xTable1"-->
      <!--        :loading="loading"-->
      <!--      >-->
      <!--        <vxe-column title="操作" width="120">-->
      <!--          <template #default="{ row }">-->
      <!--            <span-->
      <!--              class="changeBtn"-->
      <!--              @click="changeBtn(row)"-->
      <!--              v-has="'WSS-50003-edit'"-->
      <!--              >修改</span-->
      <!--            >-->
      <!--            <span-->
      <!--              v-has="'WSS-50003-edit'"-->
      <!--              class="changeBtn"-->
      <!--              style="padding-left: 8px"-->
      <!--              @click="isDefault(row)"-->
      <!--              >{{ row.isDefault ? '' : '默认' }}</span-->
      <!--            >-->
      <!--          </template>-->
      <!--        </vxe-column>-->
      <!--        <vxe-column field="invoiceName" title="开票名称"></vxe-column>-->
      <!--        <vxe-column field="invoiceTaxId" title="发票税号"></vxe-column>-->
      <!--        <vxe-column field="bankAccount" title="开户行及账号"></vxe-column>-->
      <!--        <vxe-column field="invoiceAddrPhone" title="地址电话"></vxe-column>-->
      <!--        <vxe-column field="isTaxpayer" title="一般纳税人" width="120">-->
      <!--          <template #default="{ row }">-->
      <!--            <span>{{ row.isTaxpayer ? '是' : '否' }}</span>-->
      <!--          </template>-->
      <!--        </vxe-column>-->
      <!--        <vxe-column field="isDefault" title="状态" width="120">-->
      <!--          <template #default="{ row }">-->
      <!--            <span>{{ row.isDefault ? '默认' : '' }}</span>-->
      <!--          </template>-->
      <!--        </vxe-column>-->
      <!--      </vxe-table>-->
    </div>
    <!-- 弹框新增 -->
    <Modal :title="$t('Invoice.Add')" v-model="showModals">
      <Form
        :label-width="100"
        :model="formDates"
        :rules="ruleValidate"
        ref="formValidate"
      >
        <Form-item :label="$t('Invoice.Company')" prop="invoiceName">
          <Input v-model="formDates.invoiceName"> </Input>
        </Form-item>
        <Form-item :label="$t('Invoice.number')" prop="invoiceTaxId">
          <Input v-model="formDates.invoiceTaxId"> </Input>
        </Form-item>
        <div style="padding-left: 10px">
          <Checkbox v-model="formDates.isDefault">{{ $t('ShippingAddress.as') }}</Checkbox>
        </div>
        <!--        <Form-item label="开户行及账号：">-->
        <!--          <Input v-model="formDates.bankAccount"> </Input>-->
        <!--        </Form-item>-->
        <!--        <Form-item label="地址电话：">-->
        <!--          <Input v-model="formDates.invoiceAddrPhone"> </Input>-->
        <!--        </Form-item>-->
        <!--        <Form-item label="一般纳税人：">-->
        <!--          <Checkbox v-model="formDates.isTaxpayer">是</Checkbox>-->
        <!--        </Form-item>-->
        <!-- <Form-item label="是否默认：">
          <Checkbox v-model="formDates.isDefault">是</Checkbox>
        </Form-item> -->
      </Form>
      <div slot="footer" style="text-align: center">
        <Button
          type="primary"
          @click="handleSubmit('formValidate')"
          :loading="loadingBut"
          >{{ $t('Invoice.Sure') }}</Button
        >
        <Button @click="handleReset('formValidate')">{{ $t('ShippingAddress.Cancel') }}</Button>
      </div>
    </Modal>
    <!-- 修改新增 -->
    <Modal title="修改" v-model="changeModals">
      <Form
        :label-width="100"
        :model="formDates"
        :rules="ruleValidate"
        ref="formValidate"
      >
        <Form-item :label="$t('Invoice.Company')" prop="invoiceName">
          <Input v-model="formDates.invoiceName"> </Input>
        </Form-item>
        <Form-item :label="$t('Invoice.number')" prop="invoiceTaxId">
          <Input v-model="formDates.invoiceTaxId"> </Input>
        </Form-item>
        <!--        <Form-item label="开户行及账号：">-->
        <!--          <Input v-model="formDates.bankAccount"> </Input>-->
        <!--        </Form-item>-->
        <!--        <Form-item label="地址电话：">-->
        <!--          <Input v-model="formDates.invoiceAddrPhone"> </Input>-->
        <!--        </Form-item>-->
        <!--        <Form-item label="一般纳税人：">-->
        <!--          <Checkbox v-model="formDates.isTaxpayer">是</Checkbox>-->
        <!--        </Form-item>-->
        <!--        <Form-item label="是否默认：">-->
        <!--          <Checkbox v-model="formDates.isDefault">是</Checkbox>-->
        <!--        </Form-item>-->
        <div style="padding-left: 10px">
          <Checkbox v-model="formDates.isDefault">{{ $t('ShippingAddress.as') }}</Checkbox>
        </div>
      </Form>
      <div slot="footer" style="text-align: center">
        <Button
          type="primary"
          @click="handleSub('formValidate')"
          :loading="loadingCancel"
          >{{ $t('Invoice.Sure') }}</Button
        >
        <Button @click="handleReset('formValidate')">{{ $t('ShippingAddress.Cancel') }}</Button>
      </div>
    </Modal>
    <!-- 删除弹框 -->
    <Modal
      v-model="modal2"
      width="360"
      :mask-closable="false"
      :closable="false"
    >
      <div style="text-align: center">
        <h3 style="font-size: 18px; margin: 20px">{{ $t('Invoice.Are') }}</h3>
      </div>
      <div slot="footer" style="text-align: center; margin-bottom: 20px">
        <Button :loading="modal_loading" @click="btnOK">{{ $t('Invoice.Sure') }}</Button>
        <Button @click="cancel">{{ $t('ShippingAddress.Cancel') }}</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import {
  showInvoiceMessage,
  addInvoiceMessage,
  updateInvoiceMessage,
  delInvoiceMessage,
  updateIsDefault
} from '../../../api/myweb/invoice/invoice.js'
import { Deladdress } from '../../../api/myweb/address/address'
export default {
  name: 'invoice',
  components: {},
  data() {
    return {
      total: '', // 已有发票个数
      number: '',
      loadingCancel: false,
      loadingBut: false,
      loading: false,
      showModals: false,
      changeModals: false,
      modal2: false,
      modal_loading: false,
      delId: '',
      tenantName: '',
      tenantShortName: '',
      // 表格
      tableData: [
        {
          invoiceName: '',
          // updateUname: '',
          invoiceTaxId: '',
          bankAccount: '',
          invoiceAddrPhone: '',
          // invoiceTaxId: '',
          isTaxpayer: ''
          // isDefault: ''
        }
      ],
      // 弹框数据
      formDates: {
        tenantId: '',
        invoiceName: '',
        invoiceTaxId: '',
        // bankAccount: '',
        // invoiceAddrPhone: '',
        tenantName: '',
        tenantShortName: '',
        isDefault: ''
        // isTaxpayer: false
      },
      // 验证
      ruleValidate: {
        invoiceTaxId: [
          {
            required: true,
            message: '税号不能为空',
            trigger: 'blur'
          }
        ],
        invoiceName: [
          {
            required: true,
            message: '企业名称不能为空',
            trigger: 'blur'
          }
        ]
      },
      id: JSON.parse(localStorage.getItem('userdetails_leagueInfo')).tenantId
    }
  },
  created() {
    this.showInvoiceMessage()
  },
  methods: {
    // 渲染
    async showInvoiceMessage() {
      this.loading = true
      const res = await showInvoiceMessage({ tenantId: this.id })
      if (res.code == 0) {
        this.tableData = res.data.tenantInvoiceList
        this.tenantName = res.data.tenantName
        this.tenantShortName = res.data.tenantShortName
        this.total = res.data.tenantInvoiceList.length
        this.number = 5 - this.total
        this.loading = false
      }
      console.log(res)
    },
    // 设置默认
    async isDefault(row) {
      console.log(row)
      const res = await updateIsDefault({
        tenantId: this.id,
        invoiceName: row.invoiceName,
        invoiceTaxId: row.invoiceTaxId,
        id: row.id
      })
      console.log(res)
      if (res.code == 0) {
        this.$Message.success(res.data)
        this.showInvoiceMessage()
      } else {
        this.$Message.error(res.message)
      }
    },
    // 新增判断
    showBTn() {
      if (this.tableData.length < 5) {
        this.formDates = {
          tenantId: '',
          invoiceName: '',
          invoiceTaxId: '',
          // bankAccount: '',
          // invoiceAddrPhone: '',
          tenantName: '',
          tenantShortName: '',
          isDefault: false
          // isTaxpayer: false
        }
        this.showModals = true
        // 企业模糊查询
        // const res = ({invoiceName:this.formDates.invoiceName})
        // if (res.code == 0) {
        //   this.formDates = res.data
        // } else {
        //   this.$Message.error(res.message)
        // }
      } else {
        this.$Message.warning('一个商户最多只能有5个开票名称')
      }
    },
    // 新增
    handleSubmit(formValidate) {
      this.formDates.tenantId = this.id
      console.log(this.formDates.tenantId)
      this.$refs[formValidate].validate(async (valid) => {
        if (valid) {
          this.loadingBut = true
          console.log(this.formDates)
          const list = JSON.parse(JSON.stringify(this.formDates))
          console.log(list)
          list.isDefault = list.isDefault == true ? 1 : 0
          // list.isTaxpayer = list.isTaxpayer == true ? 1 : 0
          list.tenantName = this.tenantName
          list.tenantShortName = this.tenantShortName
          console.log({ ...list })
          const res = await addInvoiceMessage({ ...list })
          if (res.code == 0) {
            this.$Message.success(res.data)
            this.showModals = false
            this.loadingBut = false
            this.showInvoiceMessage()
          } else {
            // this.$Message.error(res.message)
            this.loadingBut = false
          }
        } else {
          this.$Message.error('验证失败!')
        }
      })
    },
    // 取消
    handleReset(name) {
      this.$refs[name].resetFields()
      this.showModals = false
      this.changeModals = false
    },
    // 修改
    changeBtn(row) {
      console.log(row)
      const rows = JSON.parse(JSON.stringify(row))
      this.formDates = rows
      this.formDates.isDefault = this.formDates.isDefault == 1 ? true : false
      this.changeModals = true
    },
    handleSub(formValidate) {
      this.formDates.tenantId = this.id
      this.$refs[formValidate].validate(async (valid) => {
        if (valid) {
          this.loadingCancel = true
          console.log(this.formDates)
          const list = JSON.parse(JSON.stringify(this.formDates))
          console.log(list)
          list.isDefault = list.isDefault == true ? 1 : 0
          // list.isTaxpayer = list.isTaxpayer == true ? 1 : 0
          list.tenantName = this.tenantName
          list.tenantShortName = this.tenantShortName
          // delete list.isDefault
          console.log({ ...list })
          const res = await updateInvoiceMessage({ ...list })
          if (res.code == 0) {
            this.$Message.success(res.data)
            this.changeModals = false
            this.loadingCancel = false
            this.showInvoiceMessage()
          } else {
            // this.$Message.error(res.message)
            this.loadingCancel = false
          }
        } else {
          this.$Message.error('验证失败!')
        }
      })
    },
    // 删
    del(id) {
      this.delId = id
      this.modal2 = true
    },
    async btnOK() {
      this.modal_loading = true
      const res = await delInvoiceMessage({ id: this.delId })
      if (res.status) {
        this.modal2 = false
        this.$Message.success('删除成功')
        this.modal_loading = false
        this.showInvoiceMessage()
      }
    },
    // 取消
    cancel() {
      this.modal2 = false
      this.delId = ''
    }
  },
  computed: {},
  watch: {}
}
</script>
<style lang='less' scoped>
.w100 {
  width: 100px !important;
}
.mb10 {
  margin-bottom: 10px !important;
}
.pl10 {
  padding-left: 10px !important;
}
.pr10 {
  padding-right: 10px !important;
}
.borderB {
  border-bottom: 1px solid #e2e2e2;
}
.topClass {
  width: 98%;
  min-height: 60px;
  margin-bottom: 10px;
  background: #ffffff;
  -webkit-box-shadow: 2px 2px 30px #e2e2e2 !important;
  box-shadow: 2px 2px 30px #e2e2e2 !important;
  opacity: 1;
  padding-left: 10px;
  padding-top: 10px;
  display: flex;
  align-items: center;
  h3 {
    width: 64px;
    height: 16px;
    font-size: 16px;
    font-family: Source Han Sans CN;
    font-weight: bold;
    line-height: 0px;
    color: #505050;
    opacity: 1;
  }
}
.main {
  width: 98%;
  margin-top: 10px;
  height: 100%;
  min-height: 750px;
  background: #ffffff;
  -webkit-box-shadow: 2px 2px 30px #e2e2e2 !important;
  box-shadow: 2px 2px 30px #e2e2e2 !important;
  opacity: 1;
  padding-left: 10px;
  padding-top: 10px;
  .main-top {
    /*margin-top: 20px;*/
    /*margin-bottom: 20px;*/
  }
  .changeBtn {
    color: #2d8cf0;
    cursor: pointer;
  }
  .main-total {
    /*font-size: 16px;*/
    font-weight: 500;
    color: #434343;
    padding: 12px 0 12px 0px;
    /*padding: 12px 0 12px 20px;*/
    /*background-color: #f2f2f2;*/
    /*letter-spacing: 1px;*/
    /*margin-bottom: 35px;*/
    i {
      color: #e90d0d;
    }
  }
  .main-center {
    padding-left: 20px;
    font-family: Source Han Sans CN;
    opacity: 1;
    .itemFlexClass {
      display: flex;
      padding-top: 44px;
      .itemLeftClass {
        flex: 9;
        display: flex;
        flex-direction: column;
        .itemLeftTopClass {
          display: flex;
          flex-direction: row;
        }
        .h3 {
          font-size: 16px;
          font-weight: bold;
          color: #505050;
        }
        .invoiceTaxId {
          font-size: 14px;
          color: #c2c2c2;
        }
        .defauldAddress {
          display: flex;
          justify-content: center;
          align-items: center;
          span {
            width: 40px;
            /*text-align: center;*/
            /*color: #000c17;*/
            /*font-size: 12px;*/
            /*background-color: #e2e2e2;*/
            /*border-radius: 3px;*/
          }
          text-align: center;
          color: #505050;
          font-size: 14px;
          background-color: #e7e7e9;
          border-radius: 3px;
        }
      }
      .itemRightClass {
        flex: 1;
        display: flex;
        .span-btn {
          width: 28px;
          font-size: 14px;
          color: #377cf1;
          margin: 7px;
          cursor: pointer;
          text-align: right;
        }
      }
    }
  }
}
</style>